const CONFIG = {
    FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL,
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};

export default CONFIG;
